import { useRef } from 'react';
import { breakpoints } from '@ui/css';
import { LinkButton } from '@ui/kit';
import { useElementSize, ShowFor } from '@utils/react';
import { useFinishAction } from '../../state/actions/finish.js';
import { footerSize, footer, progressWrapper, bulletsWrapper, actions, finishButton } from './_task-footer.style.js';
import { TaskActions } from './atom.actions/_actions.js';
import { Bullets } from './atom.bullets/_bullets.js';
import { jsxs, jsx } from 'react/jsx-runtime';

function TaskFooter(props) {
  const ref = useRef(null);
  const onFinish = useFinishAction();
  useElementSize(ref, {
    enabled: !!props.rootRef,
    applyTo: props.rootRef ?? null,
    axis: "vertical",
    varName: footerSize.propName
  });
  return /*#__PURE__*/jsxs("footer", {
    ref: ref,
    className: footer,
    children: [/*#__PURE__*/jsx("div", {
      className: progressWrapper,
      children: /*#__PURE__*/jsx("div", {
        className: bulletsWrapper,
        children: /*#__PURE__*/jsx(Bullets, {})
      })
    }), /*#__PURE__*/jsx(TaskActions, {
      className: actions
    }), /*#__PURE__*/jsx(ShowFor, {
      breakpoint: breakpoints.mobile,
      className: finishButton,
      children: /*#__PURE__*/jsx(LinkButton, {
        theme: "inline",
        onClick: () => onFinish(),
        children: "Afslut og se resultat"
      })
    })]
  });
}

export { TaskFooter };
//# sourceMappingURL=_task-footer.js.map
